import {Moon, Sun} from 'lucide-react';
import { useEffect, useState } from 'react';

const STORAGE_KEY = 'easywork-theme';

function readInitialTheme(): boolean {
  if (typeof window === 'undefined') return true;
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== 'light';
  } catch {
    return true;
  }
}

interface ThemeToggleProps {
  className?: string;
}

function ThemeToggle({ className = '' }: ThemeToggleProps) {
  const [isDark, setIsDark] = useState<boolean>(readInitialTheme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('light', !isDark);
    root.classList.toggle('dark', isDark);
    try {
      window.localStorage.setItem(STORAGE_KEY, isDark ? 'dark' : 'light');
    } catch {
      // ignora indisponibilidade do storage
    }
  }, [isDark]);

  const label = isDark ? 'Tema escuro ativado (Dark)' : 'Tema claro ativado (Light)';

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      aria-label={label}
      title={label}
      onClick={() => setIsDark((prev) => !prev)}
      className={`relative inline-flex items-center h-10 w-[80px] rounded-full border transition-colors duration-300 shadow-lg shrink-0 ${
      isDark ?
      'bg-[#2A1A15]/60 border-[#5D4037]/60' :
      'bg-[#EFE3D9] border-[#C9B4A5]'} ${
      className}`}>

      <span
        className={`absolute text-xs font-light italic tracking-[0.04em] transition-all duration-300 ${
        isDark ? 'right-2 text-gray-300' : 'left-2 text-[#6D4C41]'}`}>

        {isDark ? 'Dark' : 'Light'}
      </span>

      <span
        className={`absolute top-1 left-1 w-8 h-8 rounded-full flex items-center justify-center shadow-md transition-transform duration-300 ease-out ${
        isDark ?
        'translate-x-0 bg-gradient-to-br from-[#C62828] to-[#E53935] text-white' :
        'translate-x-[42px] bg-white text-[#5D4037]'}`}>

        {isDark ? <Moon size={15} /> : <Sun size={15} />}
      </span>
    </button>);

}

export default ThemeToggle;
